import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class SoilEcAttribute extends Sensor {
  public soilEcChart: any;
  public extSatChart: any;
  private soilEcSensor: any[];
  private extSatSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];


  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.soilEcChart = null;
    this.soilEcSensor = [];
    this.extSatSensor = [];


  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();

    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;

      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.soilEcSensor, position);
      this.ensureArraySize(this.extSatSensor, position);
      this.soilEcSensor[position].push([timestamp, element.soilEc]);
      this.extSatSensor[position].push([timestamp, element.extSat]);

    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredSoilEc = this.soilEcSensor.filter(series => series.length > 0);
    const filteredExtSat = this.extSatSensor.filter(series => series.length > 0);


    const positionNodeSoilEc = this.soilEcSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    const positionNodeExtSat = this.extSatSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);


    this.soilEcChart = this.getConfigChar(
      'soilEc',
      this.getChartSeriesNewNode('CONDUCTIVIDAD ELÉCTRICA', filteredSoilEc, positionNodeSoilEc),
      this.getRanges('soilEc'),
      this.getLimits('soilEc')
    );

    this.extSatChart = this.getConfigChar(
      'extSat',
      this.getChartSeriesNewNode('EXTRACTO SATURADO', filteredExtSat, positionNodeExtSat),
      this.getRanges('extSat'),
      this.getLimits('extSat')
    );
  }

  public hasSoilEcSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.soilEcSensor.length &&
      this.soilEcSensor[index].length > 0
    );
  }

  public getSoilEcSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.soilEcSensor.length) {
      const sensorData = this.soilEcSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public hasExtSatSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.extSatSensor.length &&
      this.extSatSensor[index].length > 0
    );
  }

  public getExtSatSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.extSatSensor.length) {
      const sensorData = this.extSatSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }


  public static getVariables(): any[] {
    return [
      { title: 'Conductividad Eléctrica', value: 'soilEc' },
      { title: 'Conductividad del Extracto Saturado', value: 'extSat' }
    ];
  }
}
